import { Stack, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY } from 'shared';

export const OnramperErrorBox = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{ padding: 1.75, borderRadius: '4px', aspectRatio: '8 / 9', background: COLOR_BG_SECONDARY }}
    >
      <Typography variant="body1" className="secondary" fontWeight={500} mb={1.5}>
        Payment Method Unavailable
      </Typography>
      <Typography variant="body2" className="secondary" textAlign="center" fontWeight={500} mb={2}>
        We&#39;re unable to process Onramper crypto purchases for this token/network combination at this time.
        <br />
        Please cancel the order and try selecting a different asset or check back later.
        <br />
        <br />
        For assistance, please contact our support team.
      </Typography>
    </Stack>
  );
};
